module.exports = __webpack_public_path__ + "img/wallpaper-feed-a-sustainable-future.3e94fa9a.png";